import { render, staticRenderFns } from "./formativetest.vue?vue&type=template&id=3e7982da&"
import script from "./formativetest.vue?vue&type=script&lang=js&"
export * from "./formativetest.vue?vue&type=script&lang=js&"
import style0 from "./formativetest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports